import { render, staticRenderFns } from "@/templates/account/passwordChange.html?vue&type=template&id=188b4616&scoped=true&"
import script from "./PasswordChange.vue?vue&type=script&lang=js&"
export * from "./PasswordChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188b4616",
  null
  
)

export default component.exports